import React from 'react'

export default function SubHeading({text}) {

  return (
    <h3 className='headings'>{text}</h3>
  )
}
